export const countData = async url => {
  const data = await fetch(url);
  const rs = await data.json();
  return rs.length;
};

export const getData = async url => {
  const data = await fetch(url);
  const rs = await data.json();
  return rs;
};

export const getListNewsBanner = async url => {
  const data = await fetch(url);
  const rs = await data.json();
  console.log("rs 2 :>> ", rs);
  return rs;
};
